import Box from '@mui/material/Box';
// import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import React from 'react';

export default function SageAiDisclaimer() {
  return (
    <Box
      data-testid="sage-disclaimer"
      sx={{
        alignItems: 'center',
        bgcolor: '#fafafa',
        boxSizing: 'border-box',
        display: 'flex',
        gap: 0.5,
        justifyContent: 'center',
        minHeight: 24,
        px: 0.75,
        py: 0.25,
        width: '100%',
      }}
    >
      <InfoIcon sx={{ color: '#7d8793', flexShrink: 0, fontSize: 12 }} />
      <Typography
        sx={{
          color: '#7d8793',
          fontSize: 11,
          lineHeight: 1.4,
          textAlign: 'center',
        }}
      >
        Sage is an AI tool and can make mistakes. Please double check your
        response.
      </Typography>
      {/* Placeholder: no destination page yet */}
      {/* <Link
        component="button"
        onClick={() => undefined}
        sx={{ fontSize: 11, ml: 0.5 }}
        type="button"
        underline="hover"
      >
        Learn more
      </Link> */}
    </Box>
  );
}
